<template>
    <div v-if="hasMeasurement" class="uxo-item__technical-information">
        <h3 class="mb-2">Technical Information</h3>
        <div class="d-block d-md-flex">
            <div class="technical-information mr-md-3 mb-2 mb-md-0">
                <ul class="rows t-navy fs-18">
                    <template v-for="(measurement, key) in hazard.measurement">
                        <li v-if="measurement && key !== 'measurement_unit'" class="row px-2 py-12px t-navy w-100">
                            <div class="column is-4 p-0">{{measurementTitle(key)}}:</div>
                            <div class="column is-4 p-0 font-weight-light">{{measurementToFixed(measurement)}} {{measurementUnit(key)}}
                            </div>
                            <div class="column is-4 p-0 font-weight-light">
                                {{convertMeasurement(key, measurement, hazard.measurement_unit)}} {{measurementUnit(key,
                                'il')}}
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <div class="technical-information" >
                <ul class="rows t-navy fs-18">
                    <template v-for="(meta) in hazard.meta_keys">
                        <li v-if="metaValue(meta)" class="row px-2 py-12px t-navy w-100">
                            <div class="column is-4 p-0">{{meta.name}}:</div>
                            <div class="column is-7 p-0 font-weight-light">{{metaValue(meta)}}</div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "CatUxoTechnicalInformation",
        methods: {
            metaValue(meta) {
                if (meta.meta_value.value) {
                    return meta.meta_value.value;
                }

                return '';
            },
            measurementToFixed(measurement) {
                return parseFloat(measurement).toFixed(2).replace(/\.00$/, '');;
            },
            convertMeasurement(key, measurement, type) {
                let convertedMeasurement;
                switch (key) {
                    case 'diameter':
                    case 'length':
                    case 'width':
                    case 'height':
                    case 'length_with_fuze':
                    case 'length_without_fuze':
                        convertedMeasurement = type === 'il' ? measurement / 0.03937007874 : measurement * 0.03937007874;
                        break;
                    case 'weight':
                    case 'explosive_weight':
                    case 'propellant_weight':
                    case 'operating_weight':
                    case 'wh_weight':
                        convertedMeasurement = type === 'il' ? measurement * 0.45359237 : measurement / 0.45359237;
                        break;
                    case 'operating_pressure':
                        convertedMeasurement = type === 'il' ? measurement / 0.0001450377 : measurement * 0.0001450377;
                        break;
                    default:
                        return;
                }

                return parseFloat(convertedMeasurement).toFixed(2).replace(/\.00$/, '');
            },
            measurementUnit(key, type) {
                switch (key) {
                    case 'diameter':
                    case 'length':
                    case 'width':
                    case 'height':
                    case 'length_with_fuze':
                    case 'length_without_fuze':
                        return type === 'il' ? 'in' : 'mm';
                    case 'weight':
                    case 'wh_weight':
                    case 'explosive_weight':
                    case 'propellant_weight':
                    case 'operating_weight':
                        return type === 'il' ? 'lbs' : 'kg';
                    case 'operating_pressure':
                        return type === 'il' ? 'Pa' : 'psi';
                    default:
                        return;
                }
            },
            measurementTitle(key) {
                switch (key) {
                    case 'length_with_fuze':
                        return 'W/Fuze'
                    case 'length_without_fuze':
                        return 'WO/Fuze'
                    case 'weight':
                        return 'AUW'
                    case 'wh_weight':
                        return 'WH'
                    case 'explosive_weight':
                        return 'Fill'
                    case 'propellant_weight':
                        return 'Propellant'
                    case 'operating_weight':
                        return 'Operating'
                }
                return  key.replace(/_/g, ' ').replace(/\b\S/g, t => t.toUpperCase());
            }
        },
        computed: {
            ...mapState('hazards', [
                'hazard'
            ]),
            hasMeasurement() {
                // Could do with a refactor
                const measurements = [...Object.values(this.hazard.measurement).filter((measurement)=>{
                    if (measurement && measurement !== 'null' && measurement !== 'mt' && measurement !== 'il') return measurement
                })]

                return measurements.length
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .row {
        &:nth-child(even) {
            background: $c-white;
        }

        &:nth-child(odd) {
            background: $c-light-grey;
            color: $c-navy-blue;
        }
    }

    @include media-breakpoint-up(md) {
        .technical-information {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/uxo/TechnicalInformation.vue